import React, {useRef} from "react";
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';

export const Tabs = (props) => {

  const {tabsData} = props;
  const tabsRef = useRef([]);

  const renderTabsHeadings = () => {
    return tabsData ? tabsData.map((tab, index) => {
      return (
        <Nav.Item key={index}>
          <Nav.Link className={`zg-tab mb-0 me-4 ${index !== 0 ? 'mt-md-4' :''}`} eventKey={index} ref={(el) => (tabsRef.current[index] = el)}>
            <span className="zg-tab__title subtitle">
              {tab.title}
            </span>
            <span className="zg-tab__label">{`${index < 9 ? '0' : ''}${index + 1}`}</span>
          </Nav.Link>
        </Nav.Item>
      )
    }) : '';
  }

  const renderTabsContent = () => {
    return tabsData ? tabsData.map((tabContent, index) => {
      return (
        <Tab.Pane
          key={index}
          eventKey={index}>
          <div className="border rounded-4 p-4 min-h-100">
            <span className="zg-label bg-orange mb-5">{`${index < 9 ? '0' : ''}${index + 1}`}</span>
            <div className="text-block zg-text-md">
              {tabContent.text}
            </div>
          </div>

        </Tab.Pane>
      )
    }) : ''
  }

  return (
    <Tab.Container
      id="tabs"
      defaultActiveKey='0'

    >
      <div className="row">
        <div className="col-12 col-md-5 col-xl-6">
          <Nav variant="pills" className="mb-4 mb-md-0 d-flex flex-md-column zg-radio-wrap flex-nowrap">
            {renderTabsHeadings()}
          </Nav>
        </div>
        <div className="col-12 col-md-7 col-xl-6">
          <Tab.Content>
            {renderTabsContent()}
          </Tab.Content>
        </div>
      </div>

    </Tab.Container>
  )
}
